import { Button } from "@/src/components/Button";
import { ApiCallsTypes } from "@/src/components/pages/StepPage/components/apiCalls/contants";
import { apiCallsModalStore } from "@/src/components/pages/StepPage/components/apiCalls/modalStore";
import {
  AgreementModalData,
  ApiCallModalType,
} from "@/src/components/pages/StepPage/components/apiCalls/types";
import { useHandleApiCall } from "@/src/components/pages/StepPage/components/apiCalls/useHandleApiCall";
import { ParsedValue } from "@/src/components/TextWithValue";
import { WebShopIcon } from "@/src/components/WebShopIcon";
import { strings } from "@/src/shared/strings";
import { CircularProgress, IconButton, Stack, Typography } from "@mui/material";
import { Suspense, useState } from "react";
import { useStepsNavigation } from "../useStepsNavigation";
import { useOtpTemplateCode } from "@/src/components/pages/StepPage/components/apiCalls/Modals/useOtpTemplateCode";
import { useFormContext } from "react-hook-form";
import { getUrlByDataStorageFile } from "@/src/components/Action";
import { ModalHeader } from "./components/ModalHeader";
import { ButtonLoader, PageLoader } from "@/src/components/Loaders";
import { isMobile } from "react-device-detect";
import { useAnalytics } from "../../useAnalytics";
import { AnalyticsComponents } from "@/src/shared/models/analytics";

export const AgreementModal: React.FC<AgreementModalData> = ({
  cancelText = "скасувати",
  confirmText = "Підтвердити договір",
  description = "",
  linkText = "Посилання на пропозицію",
  onConfirmClick,
  onCancelClick,
  onLinkClick,
}) => {
  const { callComponentEvent } = useAnalytics();

  const { close, open } = apiCallsModalStore();
  const { handleApiCallByName } = useHandleApiCall(true);
  const { goBack, goNext, goToStep } = useStepsNavigation();
  const { getValues } = useFormContext();
  const templateCode = useOtpTemplateCode();
  const [isSubmitPending, setIsSubmitPending] = useState(false);
  const [isLinkPending, setIsLinkPending] = useState(false);

  const onCancel = () => {
    callComponentEvent(AnalyticsComponents.AGREEMENT_CANCEL);

    if (onCancelClick) {
      onCancelClick({
        nextStep: goNext,
        prevStep: goBack,
        specificStep: goToStep,
        handleApiCallByName
      });
    } else {
      close();
    }
  };
  const onSubmit = async () => {
    callComponentEvent(AnalyticsComponents.AGREEMENT_CONFIRM);
    setIsSubmitPending(true);

    if (onConfirmClick) {
      await onConfirmClick({
        nextStep: goNext,
        prevStep: goBack,
        specificStep: goToStep,
        handleApiCallByName
      });
    } else {
      try {
        const response = await handleApiCallByName(
          ApiCallsTypes.SEND_IDENTIFICATION_CODE,
          true,
          {
            formDataOverride: {
              ...getValues(),
              templateCode: templateCode,
            },
          },
        );
        if (response) {
          open(ApiCallModalType.OTP, response);
        }
      } catch (error) {
        console.log("error", error);
      }
    }
    setIsSubmitPending(false);
  };

  const onLink = async () => {
    const payload = getValues("offerPrintout");
    if (!payload) return;
    setIsLinkPending(true);

    const queryParams = new URLSearchParams({
      uuid: payload.uuid,
      fileName: payload.fileName,
      sourceId: payload.sourceId,
    }).toString();

    window.open(`/download?${queryParams}`, "_blank", "noopener,noreferrer");
    setIsLinkPending(false);
  };

  return (
    <Stack
      className={
        "max-w-[524px] rounded-xl bg-white center-modal max-md:h-full max-md:animate-up-modal max-md:items-start max-md:rounded-none max-md:bottom-modal"
      }
    >
      {isMobile && (
        <div className="h-14 w-full md:hidden">
          <ModalHeader onCancel={onCancel} />
        </div>
      )}
      <div className="flex flex-col items-center gap-4 p-6 max-md:h-full">
        <Stack className={"w-full flex-center-row"}>
          <div className="flex flex-1 md:justify-center">
            <Typography
              variant={"h1"}
              component={"h3"}
              className={
                "flex-0 w-fit justify-center text-center text-2xl font-semibold max-md:text-start"
              }
            >
              {strings.orderAgreementModal.confirmAgreement}
            </Typography>
          </div>
          <IconButton onClick={onCancel} className="max-md:hidden">
            <WebShopIcon name={"close"} className="fill-blue" />
          </IconButton>
        </Stack>
        <Stack className="flex flex-col">
          <Typography component={"p"}>
            {<ParsedValue value={description} />}
          </Typography>
          <Button
            variant="text"
            fullWidth={false}
            startIcon={<WebShopIcon name="link" />}
            loading={isLinkPending}
            className="w-fit justify-start normal-case"
            onClick={onLink}
          >
            {linkText}
          </Button>
        </Stack>
        <Stack className="flex w-full flex-col items-center justify-end gap-3 max-md:mt-auto md:flex-row">
          <Button
            onClick={onCancel}
            variant="outlined"
            className="w-fit max-md:w-full"
          >
            {cancelText}
          </Button>
          <Button
            onClick={onSubmit}
            loading={isSubmitPending}
            className="w-fit max-md:w-full"
          >
            {confirmText}
          </Button>
        </Stack>
      </div>
    </Stack>
  );
};
